<template>
  <v-layout>
    <v-row>
      <v-col cols="12" md="3" xl="2">
        <v-card>
          <v-card-title>
            Filtry
          </v-card-title>
          <v-card-text>
            <CompaniesFilters></CompaniesFilters>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="9" xl="10">
        <v-card>
          <v-card-title>
            Lista firm
          </v-card-title>
          <v-card-text>
            <data-table
                :headers="headers"
                :items="companies"
                :options.sync="options"
                :server-items-length="total"
                :loading="loading"
                class="row-pointer"
                @click:row="(company) => $router.push({name: 'price-list-company-details', params: { id: company.id }}).catch(()=>{})"
            >
              <template v-slot:top>
                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="headline">
                      Czy na pewno chcesz usunąć tę firmę?
                    </v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="onDeleteDialogClosed">
                        Anuluj
                      </v-btn>
                      <v-btn color="blue darken-1" text @click="onDeleteConfirmed">
                        Tak
                      </v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.name="{ item }">
                <span v-html="formatEmpty(item.name, 'Brak', 'red--text')"/>
              </template>
              <template v-slot:item.public="{ item }">
                <v-switch
                    :input-value="mapBool(item.public, true)"
                    :label="false !== item.public ? 'Tak' : 'Nie'"
                    readonly
                    disabled
                />
              </template>
              <template v-slot:item.nip="{ item }">
                <span v-html="formatEmpty(item.nip, 'Brak', 'red--text')"/>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ localDateTime(item.createdAt, 'Brak') }}
              </template>
              <template v-slot:item.updatedAt="{ item }">
                {{ localDateTime(item.updatedAt, 'Nie modyfikowano') }}
              </template>
              <template v-slot:item.actions="{ item }"
                        class="text-end"
              >
                <v-icon
                    class="mx-2"
                    :disabled="loading"
                    @click="onDeleteBtnTriggered(item, $event)"
                    title="Usuń firmę."
                >
                  mdi-delete
                </v-icon>
              </template>
            </data-table>
            <div class="text-center">
              <v-btn
                  class="mx-2"
                  @click="add"
              >
                Dodaj nową firmę
              </v-btn>
              <v-btn
                  class="mx-2"
                  @click="refresh"
              >
                Odśwież
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import api from '@/services/api';
import CompaniesFilters from "@/components/price-list/CompaniesFilters";
import DataTable from "@/components/data-table/DataTable";
import filters from "@/mixins/filters";
import formatters from "@/mixins/formatters";
import {getDatatableParams, setDatatableOptions} from '@/utils/helpers';

export default {
  mixins: [
    filters,
    formatters,
  ],
  components: {
    CompaniesFilters,
    DataTable,
  },
  data() {
    return {
      total: 0,
      companies: [],
      loading: false,
      options: {},
      headers: [
        {text: 'Nazwa', value: 'name', sortable: false},
        {text: 'Publiczna', value: 'public', sortable: false},
        {text: 'NIP', value: 'nip', sortable: false},
        {text: 'Utworzono', value: 'createdAt', sortable: false},
        {text: 'Ost. aktualizacja', value: 'updatedAt', sortable: false},
        {text: 'Akcje', value: 'actions', sortable: false},
      ],
      filters: {},
      dialogDelete: false,
      editedIndex: -1,
      urlDelete: '/api/price-list/company/{id}',
    }
  },
  mounted() {
    const self = this;

    this.$root.$on('loadPriceListCompanies', (options) => {
      self.load(options);
    });
  },
  watch: {
    options: {
      handler() {
        this.load();
        setDatatableOptions.call(this);
      },
      deep: true,
    },
    dialogDelete(value) {
      value || this.onDeleteDialogClosed();
    },
  },
  methods: {
    add() {
      this.$router
          .push({name: 'price-list-company-add'})
          .catch(() => {
          });
    },
    appendFilters(params, filters) {
      if (!(filters instanceof Object)) {
        return;
      }

      this.appendStringFilterIfNonEmpty(params, 'companyName', filters.companyName);
      this.appendStringFilterIfNonEmpty(params, 'description', filters.description);
      this.appendStringFilterIfNonEmpty(params, 'nip', filters.nip);
      this.appendBoolFilterIfNonEmpty(params, 'public', filters.public, true);
      this.appendBoolFilterIfNonEmpty(params, 'notPublic', filters.notPublic, true);
    },
    delete(index) {
      if (this.loading) {
        return;
      }

      this.loading = true;
      const item = this.companies[index];

      api
          .delete(
              this.urlDelete.replace('{id}', item.id)
          )
          .then(() => {
            this.companies.splice(index, 1);
            this.total--;

            if (!this.companies.length) {
              this.options.page--;
            }

            this.onDeleteDialogClosed();
            this.$root.$emit('notifySuccess', {
              html: `Firma została usunięta.`,
            });
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się usunąć firmy.',
              error,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    deleteItem(item) {
      this.editedIndex = this.companies.indexOf(item);
      this.dialogDelete = true;
    },
    formatEmpty(value, onEmptyHtml = 'Brak', onEmptyClasses = 'orange--text') {
      if (null !== value && '' !== value) {
        return value;
      }

      return `<em class="${onEmptyClasses}">${onEmptyHtml}</em>`;
    },
    load(options = {}) {
      if (this.loading) {
        return;
      }

      this.loading = true;
      options = options || {};

      let filters = {};
      this.appendFilters(filters, options.filters || this.filters);
      this.filters = filters; // Remember them.

      const {page, itemsPerPage} = this.options;
      const params = {
        ...filters,
        offset: page > 1 ? itemsPerPage * (page - 1) : 0
      };

      if (-1 !== itemsPerPage) {
        params.limit = itemsPerPage;
      }

      api.get('/api/price-list/company', {params})
          .then((response) => {
            this.companies = response.data.items;
            this.total = response.data.total;

            if (options.onSuccess) {
              options.onSuccess();
            }
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się pobrać listy firm.',
              error,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    mapBool(value, onNull = false) {
      if (null === value) {
        return onNull;
      }

      return !!value;
    },
    refresh() {
      const self = this;
      this.$root.$emit('loadPriceListCompanies', {
        onSuccess: () => {
          self.$root.$emit('notify', {
            html: 'Lista została odświeżona.',
          });
        }
      });
    },
    stopRowClickPropagation(event) {
      // The following line is required to avoid triggering onRowClicked() method.
      event.cancelBubble = true;
      event.stopPropagation();
    },
    onDeleteBtnTriggered(item, event) {
      this.stopRowClickPropagation(event);
      this.deleteItem(item);
    },
    onDeleteConfirmed() {
      this.delete(this.editedIndex);
    },
    onDeleteDialogClosed() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
      });
    },
  },
  created() {
    getDatatableParams.call(this);
    this.load();
  }
}
</script>

<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>